import { memo } from "react";

import {
  ARN,
  parse as parseARN,
  validate as validateARN,
} from "@aws-sdk/util-arn-parser";

import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import NoneFinding from "../../none/FindingDetails";

import { Finding } from "stores/FindingStore";

import ARNDataList from "./ARNDataList";

// -----------------------------------------------------------------------------

const AWSFindingDetails = memo(function AWSFindingDetails({
  finding,
}: AWSFindingDetailsProps): JSX.Element {
  // parse ARNs
  const isValid = validateARN(finding.asset.split(";")[0]);
  if (!isValid) return <NoneFinding finding={finding} />;

  const assetARN: ARN = parseARN(finding.asset.split(";")[0]);
  const actorARN = finding.actor
    ? parseARN(finding.actor.split(";")[0])
    : undefined;

  //
  return (
    <Stack sx={{ width: "100%" }} spacing={1}>
      <Typography variant="h6" fontWeight="bold">
        Asset
      </Typography>
      <ARNDataList arn={assetARN} details={finding.details} />

      {actorARN != null ? (
        <>
          <Typography variant="body1" fontWeight="bold" sx={{ mt: 1 }}>
            Actor
          </Typography>
          <ARNDataList arn={assetARN} details={finding.details} />
        </>
      ) : null}
    </Stack>
  );
});

export default AWSFindingDetails;

// -----------------------------------------------------------------------------

interface AWSFindingDetailsProps {
  finding: Finding;
}
